/*
 * @Author: zhangyuan zhangyuan@cheyipai.com
 * @Date: 2022-06-28 10:19:02
 * @LastEditors: zhangyuan your_email
 * @LastEditTime: 2023-10-27 10:42:45
 * @FilePath: /report-template/src/util/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 判断当前容器是移动端还是pc端
 * 0 移动端
 * 1 pc端
 * */
const getUserBrowser = () => {
    const ua = navigator.userAgent.toLowerCase();
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(ua)) {
        return 0;
    } else {
        return 1;
    }
};
// scrollTop 距顶部距离
const scrollTop = (el: Window & any, from: number, to: number, duration: number) => {
    if (!from) {
        from = 0;
    }
    if (!duration) {
        duration = 500;
    }
    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = window.webkitRequestAnimationFrame ||
        window.requestAnimationFrame || function (callback) {
            return window.setTimeout(callback, 1000 / 60);
        };
    }
    let difference = Math.abs(from - to);
    let _step = Math.ceil((difference / duration) * 50);
    function scroll(start: number, end: number, step: number) {
        if (start === end) return;
        let d = start + step > end ? end : start + step;

        if (start > end) {
            d = start - step < end ? end : start - step;
        }

        el.scrollTo(d, d, step);
        // if (el === window) {
        //     window.scrollTo(d, d);
        // } else {
            // el.scrollTop = d;
        // }
        window.requestAnimationFrame(function () {
            return scroll(d, end, step);
        });
    }
    scroll(from, to, _step);
};
// url转对象
const parseQueryString = function(url){
	url = !url ? window.location.href : url;
	if(url.indexOf('?')===-1){
		return {}
	}
	let search = url[0] === '?' ? url.substr(1) : url.substring(url.lastIndexOf('?') + 1);
	if(search === '') {
		return {}
	}
	search = search.split('&');
	let query = {};
	for(let i=0;i<search.length;i++){
		let pair = search[i].split('=');
		query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
	}
	return query
}
// 2021-02-01转2021年02月01日
const parseDate = function(date) {
    let dateArr = date.split('-');
    return dateArr[0] + '年' + dateArr[1] + '月' + dateArr[2] + '日';
}
// 防抖函数
export function debounce(func, wait) {
    let timeout;
    return function (this: any) {
        clearTimeout(timeout);
        timeout = setTimeout(
            // eslint-disable-next-line prefer-rest-params
            () => { func.apply(this, arguments); } //修复
            , wait
        );
    };
}


export default {
    getUserBrowser,
    scrollTop,
    parseQueryString,
    parseDate,
    debounce
}